/**
 * Canonical route table (contract §5). Owned by the orchestrator.
 * Import paths from here; never hardcode route strings in features.
 */

export const PATHS = {
  root: '/',
  welcome: '/welcome',
  onboarding: '/onboarding',
  role: '/role',
  auth: {
    clientLogin: '/auth/client/login',
    clientRegister: '/auth/client/register',
    caregiverLogin: '/auth/caregiver/login',
    caregiverRegister: '/auth/caregiver/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    callback: '/auth/callback',
  },
  legal: {
    privacy: '/privacy',
    terms: '/terms',
    help: '/help',
  },
  app: {
    today: '/app/today',
    remember: '/app/remember',
    planner: '/app/planner',
    breathing: '/app/breathing',
    journal: '/app/journal',
    health: '/app/health',
    places: '/app/places',
    notifications: '/app/notifications',
    more: '/app/more',
    profile: '/app/profile',
    security: '/app/security',
    accessibility: '/app/accessibility',
    data: '/app/data',
    install: '/app/install',
  },
  caregiver: {
    dashboard: '/caregiver/dashboard',
    clients: '/caregiver/clients',
    clientDetail: (clientId: string) => `/caregiver/clients/${clientId}` as const,
    clientDetailPattern: '/caregiver/clients/:clientId',
    clientSchedule: (clientId: string) => `/caregiver/clients/${clientId}/schedule` as const,
    clientSchedulePattern: '/caregiver/clients/:clientId/schedule',
    clientIntakes: (clientId: string) => `/caregiver/clients/${clientId}/intakes` as const,
    clientIntakesPattern: '/caregiver/clients/:clientId/intakes',
    clientProofs: (clientId: string) => `/caregiver/clients/${clientId}/proofs` as const,
    clientProofsPattern: '/caregiver/clients/:clientId/proofs',
    notifications: '/caregiver/notifications',
    profile: '/caregiver/profile',
    security: '/caregiver/security',
    accessibility: '/caregiver/accessibility',
  },
} as const

/** Legacy pre-rebuild routes that must redirect into the new map. */
export const LEGACY_REDIRECTS: Record<string, string> = {
  '/planner': PATHS.app.planner,
  '/onthouden': PATHS.app.remember,
  '/plaatsen': PATHS.app.places,
  '/dagboek': PATHS.app.journal,
  '/gezondheid': PATHS.app.health,
  '/ademhaling': PATHS.app.breathing,
  '/meer': PATHS.app.more,
  '/login': PATHS.auth.clientLogin,
  '/register': PATHS.auth.clientRegister,
}
